


























































import { Vue } from 'vue-property-decorator'
import { CIcon } from '@coreui/icons-vue'
import { cilFileExcel, cilUserFemalePlus, cilFilePdf } from '@coreui/icons-pro'
import mapboxgl from 'mapbox-gl'
import { mapState } from 'vuex'

import ScreenTile from '../../components/ScreenTile.vue'
import UpsertContactModal from '../../components/contact/UpsertContactModal.vue'
import RemoveItemModal from '../../components/general/RemoveItemModal.vue'
import CompanyTab from './CompanyTab.vue'
import '../../styles/contact-list.css'

interface IContact {
  id: number
  firstName: string
  lastName: string
  department: string
  position: string
  company: string
  email: string
  phoneNumber: string
  imageUrl: string | undefined
}

let map: mapboxgl.Map

export default Vue.extend({
  data: function () {
    return {
      loading: true,
      contacts: [] as IContact[],

      editItem: {} as IContact,
      removeItem: {} as IContact | null,

      showModal: false,
      showRemoveModal: false,

      excelIcon: cilFileExcel,
      pdfIcon: cilFilePdf,
      userAddIcon: cilUserFemalePlus,
      tab: 'company',
      tabs: ['company'],
    }
  },
  mounted: async function () {
    this.initMapbox()

    this.contacts = await (await fetch('/api/contacts')).json()
    this.loading = false
  },
  beforeDestroy: function () {
    map.remove()
  },
  methods: {
    upsertContact: function (item: IContact) {
      if (item) {
        if (this.editItem?.id)
          this.contacts = this.contacts.filter(
            (contact) => contact.id !== item.id
          )
        this.contacts.push(item)
      }
      this.showModal = false
      if (this.editItem?.id) this.editItem = {} as IContact
    },
    exportToExcel: function () {
      window.open('/api/contacts/excel')
    },
    exportToPDF: function () {
      window.open('/Portfolio Contacts.pdf')
    },
    removeContact: async function (id: number | undefined) {
      if (id === undefined) return

      this.showRemoveModal = false

      await fetch(`/api/contacts/${id}`, { method: 'DELETE' })

      this.contacts = this.contacts.filter((contact) => contact.id !== id)
    },
    changeTab: function (target: string) {
      const mapboxEl = this.$refs.mapbox as HTMLElement

      if (target !== 'company') mapboxEl.style.display = 'none'
      else mapboxEl.style.display = 'block'

      this.tab = target
    },
    initMapbox: async function () {
      const mapkey = await (await fetch('api/map/key')).json()
      if (!mapkey) {
        return
      }

      try {
        map = new mapboxgl.Map({
          accessToken: mapkey,
          container: 'mapbox', // HTML container id
          style: 'mapbox://styles/mapbox/light-v9', // style URL
          center: [-96.825223, 32.94471], // starting position as [lng, lat]
          zoom: 4,
        })

        map.on('load', () => {
          map.loadImage(
            'https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png', // TODO: Replace with our custom map marker once it's made
            (error, image) => {
              if (error || !image) throw error
              map.addImage('custom-marker', image)

              map.addSource('pointsSource', {
                type: 'geojson',
                data: {
                  type: 'FeatureCollection',
                  features: [
                    {
                      type: 'Feature',
                      properties: {
                        accuracy: 'rooftop',
                        place_name:
                          '14651 Dallas Parkway, Dallas, Texas 75254, United States',
                        title: 'Contract and claims administration',
                      },
                      geometry: {
                        coordinates: [-96.825223, 32.94471],
                        type: 'Point',
                      },
                      id: 'address.1390764535141240',
                    },
                    {
                      type: 'Feature',
                      properties: {
                        accuracy: 'rooftop',
                        place_name:
                          '25541 Commercentre Drive, Lake Forest, California 92630, United States',
                        title:
                          'Corporate Office, Sales support, contract and claims administration',
                      },
                      geometry: {
                        coordinates: [-117.684187, 33.665191],
                        type: 'Point',
                      },
                      id: 'address.8430962327466210',
                    },
                    {
                      type: 'Feature',
                      properties: {
                        accuracy: 'rooftop',
                        place_name: '8370 Dow Circle Strongsville, OH 44136',
                        title:
                          'Sales support, contract, and claims administration',
                      },
                      geometry: {
                        coordinates: [-81.80746414360598, 41.3473969921645],
                        type: 'Point',
                      },
                      id: 'address.8430962327466211',
                    },
                  ],
                },
              })

              map.addLayer({
                id: 'points',
                source: 'pointsSource',
                type: 'symbol',
                layout: {
                  'icon-image': 'custom-marker',
                  // get the title name from the source's "title" property
                  'text-field': ['get', 'title'],
                  'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                  'text-offset': [0, 1.25],
                  'text-anchor': 'top',
                },
              })
            }
          )
        })
        // TODO: add logic to go to a point on the map when a person taps on a location in the static list we'll make later
      } catch (e) {}
    },
  },
  computed: {
    ...mapState(['user']),
  },
  components: {
    ScreenTile,
    UpsertContactModal,
    RemoveItemModal,
    CompanyTab,
    CIcon,
  },
})
